// removed by extract-text-webpack-plugin
module.exports = {"rippleWrapper":"theme__rippleWrapper___1du30","ripple":"theme__ripple___2K8ul","rippleRestarting":"theme__rippleRestarting___3SIg3","rippleActive":"theme__rippleActive___3gBYd"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/ripple/theme.css
// module id = 1199
// module chunks = 0